






import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'Company' })
export default class Company extends BaseComponent {}
